import styled from 'styled-components/macro';

const Section = styled.div`
    padding: 1.5rem 0;
`;

export default Section;
